import { UserCheck, Users, ShieldCheck } from "lucide-react";
import { ChapterHead, Reveal } from "./motion";
import { TEAM, CLIENT_TEAM, GOVERNANCE } from "./data";

const ROLE_ICONS = [UserCheck, Users, ShieldCheck];

export const Team = () => (
  <section data-testid="chapter-team" className="chapter-print-break mx-auto max-w-7xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
    <ChapterHead
      num="05"
      title="Delivery Team & Governance"
      sub="A lean, senior Odoo delivery team of three — one project manager and two techno-functional consultants — working alongside your key users."
    />
    <div className="grid gap-6 lg:grid-cols-3">
      {TEAM.map((t, i) => {
        const Icon = ROLE_ICONS[i];
        return (
          <Reveal key={t.role} delay={i * 0.08} data-testid={`team-role-${i}`}>
            <div className="h-full rounded-sm border border-line bg-surface p-7 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-amber-500/50">
              <Icon className="h-6 w-6 text-amber-500" />
              <h3 className="font-display mt-5 text-base font-semibold leading-snug text-ink">{t.role}</h3>
              <p className="mt-3 text-sm leading-relaxed text-ink4">{t.scope}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
    <div className="mt-12 grid gap-12 lg:grid-cols-2">
      <Reveal delay={0.1}>
        <p className="font-mono2 mb-5 text-[11px] tracking-[0.3em] text-ink5 uppercase">
          Client-Side Team
        </p>
        <div className="flex flex-wrap gap-2.5">
          {CLIENT_TEAM.map((r) => (
            <span
              key={r}
              className="rounded-full border border-line bg-surface px-4 py-2 text-xs text-ink3"
            >
              {r}
            </span>
          ))}
        </div>
      </Reveal>
      <Reveal delay={0.18}>
        <p className="font-mono2 mb-5 text-[11px] tracking-[0.3em] text-ink5 uppercase">Governance</p>
        <ul className="space-y-3">
          {GOVERNANCE.map((g, i) => (
            <li key={g} data-testid={`governance-item-${i}`} className="flex items-center gap-3 text-sm text-ink3">
              <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-amber-500" />
              {g}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
